import { useApi, createApiHook } from "../utils/apiUtils";

const useUpdateAssignappQuestionnaireStatus = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const updateStatus = async (assignappQuestionnaireId, status) => {
    startLoading();
    const response = await apiPatch(
      `/assignapp_questionnaires/${assignappQuestionnaireId}/update_status`,
      "Error al actualizar el estado del cuestionario",
      { status },
    );
    setResponse(response);
    return response;
  };

  return { updateStatus, data, error, loading };
};

export default useUpdateAssignappQuestionnaireStatus;
